<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="monitor-title d-flex ai-center">
        <span>
          <icon name="video" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2">视频监控区域</span>
        <div class="monitor-status">
          <span class="status-dot"></span>
          {{ onlineCount }} / {{ cameras.length }} 在线
        </div>
      </div>
      <VideoMonitorGrid :cameras="cameras" />
    </div>
  </div>
</template>

<script>
import VideoMonitorGrid from '@/components/monitor/VideoMonitorGrid'
// import monitorVideo from '@/assets/video/aigei_video.mp4'
import monitor1Video from '@/assets/video/1.mp4'
import monitor2Video from '@/assets/video/2.mp4'
import monitor3Video from '@/assets/video/3.mp4'
import monitor4Video from '@/assets/video/4.mp4'

export default {
  components: {
    VideoMonitorGrid
  },
  data() {
    return {
      cameras: [
        { id: 'camera-01', name: '监控点', location: '监控点 01', url: monitor1Video },
        { id: 'camera-02', name: '监控点', location: '监控点 02', url: monitor2Video },
        { id: 'camera-03', name: '监控点', location: '监控点 03', url: monitor3Video },
        { id: 'camera-04', name: '监控点', location: '监控点 04', url: monitor4Video }
      ]
    }
  },
  computed: {
    onlineCount() {
      return this.cameras.filter(camera => camera.url).length
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 520px;

#bottomRight {
  padding: 14px 16px;
  height: $box-height;
  width: 100%;
  border-radius: 5px;

  .bg-color-black {
    position: relative;
    overflow: hidden;
    height: $box-height - 30px;
    border-radius: 8px;
    background: linear-gradient(180deg, rgba(12, 27, 49, 0.95), rgba(6, 14, 28, 0.97));
    box-shadow: inset 0 0 28px rgba(37, 157, 210, 0.07);

    &::before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 14px;
      right: 14px;
      height: 1px;
      background: linear-gradient(90deg, transparent, #2ddcda, transparent);
    }
  }

  .monitor-title {
    height: 38px;
    padding: 0 14px;
  }

  .text {
    color: #cbd8e8;
  }

  .monitor-status {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #8392ad;
    font-size: 11px;

    .status-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #66758e;
      box-shadow: 0 0 7px rgba(102, 117, 142, 0.6);
    }
  }
}
</style>
